import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { dataAppStorage, patientsDatabase, polyglot } from '../../../index'
import { ThumbnailBox } from '../../common/ThumbnailBox/ThumbnailBox'
import { Button } from '../../common/Button/Button'
import { ReactModal } from '../../common/ReactModal/ReactModal'
import FormRenderer from '../../common/FormRenderer/FormRenderer'
import SectionTitle from '../../common/SectionTitle/SectionTitle'
import { StaticFormGroup } from '../../common/StaticFormGroup/StaticFormGroup'
import hospital from '../../../resources/images/icons/hospital.svg'

import './style.css'
import Loading from '../../common/Loading/Loading'

export default class Admissions extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      modalIsOpen: false,
      admissionModalIsOpen: false,
      selectedAdmission: undefined
    }
    this.handleAdmissionSubmit = this.handleAdmissionSubmit.bind(this)
  }

  componentWillMount () {
    this.props.hidePatientIndicator(false)
    if (this.props.auth.isAuthenticated()) {
      if (this.props.match.params.patientId) {
        if (!this.props.patientKey) {
          this.props.patientChangeHandle(this.props.match.params.patientId)
        }
      } else {
        this.props.history.replace('/patients')
      }
    }
  }

  toggleModal () {
    this.setState({
      modalIsOpen: !this.state.modalIsOpen
    })
  }

  toggleAdmissionModal () {
    this.setState({
      admissionModalIsOpen: !this.state.admissionModalIsOpen
    })
  }

  handleAdmissionClick (admissionKey) {
    this.setState({
      selectedAdmission: admissionKey
    }, () => { this.toggleAdmissionModal() })
  }

  getAdmission (key) {
    if (this.props.patient.data && this.props.patient.data['admissions']) {
      return this.props.patient.data['admissions'][key]
    }
  }

  renderAdmissionViewer () {
    if (this.state.selectedAdmission) {
      return <AdmissionViewer
        modalIsOpen={this.state.admissionModalIsOpen}
        data={this.getAdmission(this.state.selectedAdmission)}
        toggleModal={this.toggleAdmissionModal.bind(this)} />
    }
  }

  renderAdmissions () {
    if (this.props.patient.data && this.props.patient.data['admissions']) {
      const admissions = this.props.patient.data['admissions']
      let keys = Object.keys(admissions)
      keys.sort(function (a, b) {
        return new Date(admissions[a].startDate) - new Date(admissions[b].startDate)
      })
      return keys.map(element => {
        const admission = admissions[element]
        return <div key={element} className='col-xs-12 col-sm-6 col-md-4'>
          <div className='admission-box'>
            <AdmissionBox handleAdmissionClick={this.handleAdmissionClick.bind(this)}
              admissionKey={element}
              {...this.props.match}
              admission={admission} />
          </div>
        </div>
      })
    } return <h3>{polyglot.t('staticFields.admissions.noAdmissions')}</h3>
  }

  saveData (data) {
    const admissionsRef = patientsDatabase.child(this.props.patientKey).child('data').child('admissions')
    admissionsRef.push(data)
    this.toggleModal()
  }

  handleAdmissionSubmit (data, key) {
    let dataToSubmit = data
    if (dataToSubmit.reports) {
      const files = dataToSubmit.reports
      const filesCounter = dataToSubmit.reports.length
      const filesArray = []
      Object.keys(files).forEach(key => {
        const file = files[key]
        if (file instanceof window.File) {
          if (file.size > 1000000) {
            // this.state.alertMsg.error(polyglot.t('staticFields.commonFields.maxSizeExceeded'))
            this.setState({
              loading: ''
            })
          } else {
            const storageRef = dataAppStorage.ref()
            const date = new Date()
            let uploadTask = storageRef.child(`userImages/${this.props.patientKey}/admissions/admissionReport_${date.getTime()}`).put(file)

            uploadTask.on('state_changed', snapshot => {
              // Observe state change events such as progress, pause, and resume
              // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
              let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
              console.log('Upload is ' + progress + '% done')
              switch (snapshot.state) {
                case 'paused':
                  console.log('Upload is paused')
                  break
                case 'running':
                  console.log('Upload is running')
                  break
                default:
                  break
              }
            }, function (error) {
              console.log(error)
            }, function () {
              filesArray.push(uploadTask.snapshot.downloadURL)
              dataToSubmit['reports'] = filesArray
              if (dataToSubmit && dataToSubmit['reports'].length === filesCounter) {
                this.saveData(dataToSubmit)
              }
            }.bind(this))
          }
        }
      })
    } else {
      if (dataToSubmit) {
        this.saveData(dataToSubmit)
      }
    }
  }

  renderModal () {
    return <ReactModal fullWidth name={polyglot.t('staticFields.admissions.admissionInsertion')} toggleModal={this.toggleModal.bind(this)} modalIsOpen={this.state.modalIsOpen}>
      <div className='form-horizontal'>
        <FormRenderer dataKey={'admissions'} saveData={this.handleAdmissionSubmit} fields={this.props.configuration['admissions'].elements} buttonStyle={'btn btn-default'} />
      </div>
    </ReactModal>
  }

  render () {
    if (this.props.patient) {
      window.myLogger.info(JSON.stringify({message: 'Admission Component Rendered', patient: this.props.patientKey}))
      return <div className='container'>
        <div>
          <div className='pull-right bottom-margin'>
            <Button onClick={this.toggleModal.bind(this)} text={polyglot.t('staticFields.admissions.addAdmission')} buttonType={'btn btn-success'} type={'button'} />
          </div>
        </div>
        <div className='col-xs-12'>
          {this.renderAdmissions()}
        </div>
        {this.renderModal()}
        {this.renderAdmissionViewer()}
      </div>
    } else {
      return <Loading />
    }
  }
}

Admissions.propTypes = {
  patient: PropTypes.object,
  patientKey: PropTypes.string,
  auth: PropTypes.object.isRequired,
  patientChangeHandle: PropTypes.func.isRequired,
  hidePatientIndicator: PropTypes.func.isRequired,
  configuration: PropTypes.object.isRequired
}

const AdmissionBox = (props) => {
  let startDate = moment(props.admission.startDate).format('L')
  let endDate = moment(props.admission.endDate).format('L')
  return <ThumbnailBox>
    <div className='cursor' onClick={() => { props.handleAdmissionClick(props.admissionKey) }}>
      <img className='svgTest' src={hospital} alt='Admission Icon' />
      <div className='caption'>
        <h5 className='is-centered'>{`${polyglot.t('staticFields.admissions.startDateLabel')} - ${startDate}`}</h5>
        <h5 className='is-centered'>{`${polyglot.t('staticFields.admissions.endDateLabel')} - ${endDate}`}</h5>
        <h5 className='is-centered'>{`${polyglot.t('staticFields.admissions.location')} - ${props.admission.location}`}</h5>
      </div>
    </div>
  </ThumbnailBox>
}

AdmissionBox.propTypes = {
  admissionKey: PropTypes.string.isRequired,
  admission: PropTypes.object.isRequired,
  handleAdmissionClick: PropTypes.func.isRequired
}

class AdmissionViewer extends React.Component {
  getReportLinks () {
    if (this.props.data.reports) {
      return Object.keys(this.props.data.reports).map((key, index) => {
        const obj = this.props.data.reports[key]
        return <div className='col-xs-12 no-side-padding' key={index}><a href={obj} target='_blank'>{`${polyglot.t('staticFields.admissions.report')} ${index + 1}`}</a></div>
      })
    }
  }
  render () {
    return <div className='admissions'>
      <ReactModal
        name={polyglot.t('staticFields.admissions.admission')}
        toggleModal={this.props.toggleModal}
        modalIsOpen={this.props.modalIsOpen}>
        <div className={'clearfix'}>
          <StaticFormGroup label={polyglot.t('staticFields.admissions.startDate')} value={this.props.data.startDate} />
          <StaticFormGroup label={polyglot.t('staticFields.admissions.endDate')} value={this.props.data.endDate} />
          <SectionTitle title={polyglot.t('staticFields.admissions.otherData')} size={'h4'} />
          <StaticFormGroup label={polyglot.t('staticFields.admissions.observations')} value={this.props.data.observations || polyglot.t('staticFields.commonFields.noInformation')} />
          <StaticFormGroup label={polyglot.t('staticFields.admissions.reports')} value={<div>{this.getReportLinks()}</div>} />
        </div>
      </ReactModal>
    </div>
  }
}

AdmissionViewer.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  modalIsOpen: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/general/Admissions/Admissions.js